import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onemonthcorporatecabrentalsinbanglore() {



  const cardData =
  {
    keyword: 'One-Month Corporate Cab Rentals in Bangalore',
    heading: 'Aaryan Travels: One-Month Corporate Cab Rentals in Bangalore',
    headingDescription: 'Aaryan Travels offers flexible One-Month Corporate Cab Rentals in Bangalore for companies, executives, and employees who require dedicated transportation for a short-term period. Whether it’s for visiting project teams, temporary assignments, or probationary staff commute, our fleet of sedans, SUVs, and tempo travellers is available on fixed one-month rental contracts with driver support. With trained chauffeurs, GPS-enabled cars, on-time reporting, and transparent billing, we ensure smooth travel across major business hubs like Whitefield, Electronic City, Koramangala, and Manyata Tech Park. Aaryan Travels provides hassle-free monthly cab rental solutions that eliminate the effort of daily bookings for corporate requirements in Bangalore.',

    top: 'Top Places to Visit in Bangalore with Aaryan Travels',

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a 240-acre oasis in Bangalore, known for its rare plant species, serene lake, and the iconic Glass House inspired by London’s Crystal Palace. The annual flower show draws thousands of nature lovers. Early mornings are perfect for peaceful walks among lush greenery. Lalbagh is Bangalore’s blooming escape within the city."
  },
  {
    "title": "Bangalore Palace",
    "description": "Built in 1878, Bangalore Palace resembles England’s Windsor Castle with its Tudor-style architecture, wooden interiors, and sprawling grounds. Visitors can explore royal artifacts, vintage photographs, and grand halls. The palace grounds host concerts and cultural events. Bangalore Palace is the city’s majestic reminder of regal heritage."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a 300-acre green haven in the heart of Bangalore. Its wide walking paths, lush lawns, and old trees make it ideal for jogging and relaxation. Statues, heritage buildings, and the State Central Library add charm to the surroundings. Cubbon Park is Bangalore’s refreshing lung space for all ages."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "ISKCON Temple, built on a hillock in Rajajinagar, is a magnificent marble complex dedicated to Lord Krishna. Devotees enjoy peaceful darshan, kirtans, and prasadam in the temple campus. The architectural blend of glass and stone creates a spiritual and modern feel. ISKCON Bangalore is the city’s beacon of devotion and serenity."
  },
  {
    "title": "Nandi Hills",
    "description": "Located about 60 km from the city, Nandi Hills is a favorite sunrise spot offering breathtaking views of misty valleys. The 18th-century Tipu Sultan’s Summer Palace and ancient temples add historical charm. Adventure enthusiasts enjoy trekking and cycling. Nandi Hills is Bangalore’s scenic getaway at dawn."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is one of Bangalore’s most bustling shopping lanes, lined with stores selling fashion, footwear, and accessories. Bargaining is part of the thrill here. Cafes and street food stalls add to its vibrant energy. Commercial Street is Bangalore’s go-to hub for shopping and street vibes."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is the seat of Karnataka’s legislative assembly and an architectural marvel in Neo-Dravidian style. The grand granite structure looks stunning when illuminated at night. Although entry is restricted, it is a must-see landmark from outside. Vidhana Soudha is Bangalore’s proud symbol of governance."
  },
  {
    "title": "UB City",
    "description": "UB City is Bangalore’s premier luxury mall and lifestyle destination. From global fashion brands to fine dining restaurants and rooftop lounges, it offers a taste of elite urban life. The amphitheatre often hosts live music and events. UB City is Bangalore’s hub of luxury, entertainment, and nightlife."
  },
  {
    "title": "Bannerghatta Biological Park",
    "description": "Bannerghatta Biological Park offers safari rides to spot lions, tigers, and bears in their natural habitats. It also features a butterfly park, reptile house, and zoo area. Families flock here for educational and thrilling wildlife experiences. Bannerghatta is Bangalore’s exciting retreat into the wild."
  },
  {
    "title": "MG Road & Brigade Road",
    "description": "MG Road and Brigade Road are the heartbeat of Bangalore’s urban lifestyle, filled with cafes, pubs, and shopping centers. Known for their nightlife and cosmopolitan culture, these streets are always buzzing with activity. Festival decorations make them even more vibrant. MG Road is Bangalore’s never-sleeping entertainment zone."
  }
],



  "services": [
  {
    "name": "One-Month Corporate Cab Rentals in Bangalore",
    "description": "One-Month Corporate Cab Rentals in Bangalore offer reliable, chauffeur-driven vehicles for businesses needing transport solutions on a monthly basis. Ideal for employee commutes and corporate travel."
  },
  {
    "name": "Monthly Corporate Taxi Bangalore",
    "description": "Monthly Corporate Taxi Bangalore provides cost-effective taxi services tailored for recurring business travel, ensuring punctuality and professional drivers throughout the subscription."
  },
  {
    "name": "Bangalore Corporate Cab Hire",
    "description": "Bangalore Corporate Cab Hire delivers flexible cab rental options for companies, with trained chauffeurs and a variety of vehicles suited for corporate needs."
  },
  {
    "name": "30 Day Business Cab Bangalore",
    "description": "30 Day Business Cab Bangalore is designed for short-term monthly use, perfect for temporary staff transport, corporate events, or trial services before longer contracts."
  },
  {
    "name": "Chauffeur Corporate Cab Bangalore",
    "description": "Chauffeur Corporate Cab Bangalore offers executive-class transportation with professional drivers, providing comfort and professionalism for senior management and VIP clients."
  },
  {
    "name": "Office Cab Rental Bangalore",
    "description": "Office Cab Rental Bangalore ensures safe and punctual daily employee transport with fixed routes, trained drivers, and customizable schedules aligned with company shifts."
  },
  {
    "name": "Long Term Cab Hire Bangalore",
    "description": "Long Term Cab Hire Bangalore provides extended rental plans for corporate clients, supporting staff transportation, inter-office travel, and large-scale corporate mobility."
  },
  {
    "name": "Corporate Transport Services Bangalore",
    "description": "Corporate Transport Services Bangalore offer comprehensive business travel solutions, including employee commutes and client visits with reliable vehicles and professional chauffeurs."
  },
  {
    "name": "Affordable One-Month Cab Bangalore",
    "description": "Affordable One-Month Cab Bangalore balances quality and budget-friendly pricing for startups and SMEs seeking dependable monthly corporate transport."
  },
  {
    "name": "Executive Cab Bangalore",
    "description": "Executive Cab Bangalore caters to business leaders requiring premium travel, with luxury vehicles and discreet, courteous drivers for all executive journeys."
  },
  {
    "name": "Corporate Vehicle Booking Bangalore",
    "description": "Corporate Vehicle Booking Bangalore allows businesses to easily reserve sedans, SUVs, and luxury cars with professional chauffeurs for corporate travel and events."
  },
  {
    "name": "Business Cab Subscription Bangalore",
    "description": "Business Cab Subscription Bangalore provides recurring cab services through subscription plans, reducing daily booking hassles and streamlining corporate transport management."
  },
  {
    "name": "Monthly Cab Plan Bangalore",
    "description": "Monthly Cab Plan Bangalore offers customizable monthly transportation packages for companies, supporting consistent and reliable employee travel."
  },
  {
    "name": "Best Corporate Cab Bangalore",
    "description": "Best Corporate Cab Bangalore delivers high-quality corporate transportation with professional service, timely pickups, and a focus on customer satisfaction."
  },
  {
    "name": "Company Cab Hire Bangalore",
    "description": "Company Cab Hire Bangalore supports businesses with dedicated cab services for employee transport, client visits, and executive travel, ensuring reliability and professionalism."
  }
],
"tableData": [
  ["One-Month Corporate Cab Rentals in Bangalore", "Monthly Corporate Taxi Bangalore"],
  ["Bangalore Corporate Cab Hire", "30 Day Business Cab Bangalore"],
  ["Chauffeur Corporate Cab Bangalore", "Office Cab Rental Bangalore"],
  ["Long Term Cab Hire Bangalore", "Corporate Transport Services Bangalore"],
  ["Affordable One-Month Cab Bangalore", "Executive Cab Bangalore"],
  ["Corporate Vehicle Booking Bangalore", "Business Cab Subscription Bangalore"],
  ["Monthly Cab Plan Bangalore", "Best Corporate Cab Bangalore"],
  ["Company Cab Hire Bangalore", "—"]
],




"whychoose": [
  {
    "WhyChooseheading": "One-Month Corporate Cab Rentals in Bangalore",
    "WhyChoosedescription": "Aaryan Travels offers reliable one-month corporate cab rentals in Bangalore, ideal for sustained business travel solutions."
  },
  {
    "WhyChooseheading": "Professional Drivers for Corporate Clients",
    "WhyChoosedescription": "Our experienced chauffeurs ensure punctual and courteous service throughout your monthly rental period."
  },
  {
    "WhyChooseheading": "Clean, Comfortable, and Sanitized Vehicles",
    "WhyChoosedescription": "Travel safely in air-conditioned, well-maintained cabs sanitized regularly for your comfort and health."
  },
  {
    "WhyChooseheading": "Drivers Familiar with Bangalore’s Traffic and Routes",
    "WhyChoosedescription": "Our drivers have expert knowledge of Bangalore’s roads, ensuring efficient and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Monthly Pricing with No Hidden Charges",
    "WhyChoosedescription": "Benefit from fixed monthly rates that include fuel, tolls, and driver allowances, ensuring worry-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Corporate Rentals",
    "WhyChoosedescription": "Our dedicated team is available around the clock to assist with your rental needs and queries."
  },
  {
    "WhyChooseheading": "Flexible and Customizable Rental Plans",
    "WhyChoosedescription": "Choose plans tailored to your company’s specific travel frequency and vehicle preferences."
  },
  {
    "WhyChooseheading": "Dedicated Corporate Fleet Allocation",
    "WhyChoosedescription": "Enjoy priority service with vehicles exclusively assigned to your organization for the rental duration."
  }
]




















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer one-month corporate cab rentals in Bangalore?',
    answer: 'Yes, Aaryan Travels provides flexible and reliable one-month corporate cab rental plans in Bangalore tailored to meet your business travel needs.',
  },
  {
    question: 'How can I book one-month corporate cab rentals in Bangalore with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 corporate customer support team in Bangalore.',
  },
  {
    question: 'What types of vehicles are available for one-month corporate cab rentals in Bangalore?',
    answer: 'Aaryan Travels offers a range of well-maintained sedans, SUVs, and premium cars suited for corporate travel.',
  },
  {
    question: 'Are drivers experienced and trained for one-month corporate cab rentals in Bangalore?',
    answer: 'Absolutely. Our drivers are licensed, punctual, and professionally trained to provide safe and efficient service.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for one-month rentals in Bangalore?',
    answer: 'Yes, you can specify preferred pickup and drop-off points anywhere within Bangalore and nearby business areas.',
  },
  {
    question: 'Is the one-month corporate cab rental service available 24x7 in Bangalore?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab rental services to meet your business schedules.',
  },
  {
    question: 'Are safety and hygiene protocols followed for one-month corporate cab rentals?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene guidelines.',
  },
  {
    question: 'What payment options are accepted for one-month corporate cab rentals in Bangalore?',
    answer: 'We accept payments via corporate accounts, UPI, digital wallets, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available during the one-month corporate cab rental period?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kumar',
    feedback: 'Aaryan Travels made our one-month corporate cab rental in Bangalore smooth and hassle-free with excellent drivers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Joshi',
    feedback: 'Reliable one-month corporate cab rental service by Aaryan Travels in Bangalore. Highly recommend for business travel!',
    rating: 5,
  },
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const oneMonthCorporateCabBangaloreSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "One-Month Corporate Cab Rentals in Bangalore",
  "description": "Aaryan Travels offers affordable one-month corporate cab rentals in Bangalore with chauffeur-driven vehicles for business travel, office transport, and corporate subscriptions.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Bangalore"
  },
  "serviceType": "One-Month Corporate Cab Rentals",
  "keywords": "One-Month Corporate Cab Rentals in Bangalore, Monthly Corporate Taxi Bangalore, Bangalore Corporate Cab Hire, 30 Day Business Cab Bangalore, Chauffeur Corporate Cab Bangalore, Office Cab Rental Bangalore, Long Term Cab Hire Bangalore, Corporate Transport Services Bangalore, Affordable One-Month Cab Bangalore, Executive Cab Bangalore, Corporate Vehicle Booking Bangalore, Business Cab Subscription Bangalore, Monthly Cab Plan Bangalore, Best Corporate Cab Bangalore, Company Cab Hire Bangalore"
};








  return (
    <div>
<Helmet>
  <title>One-Month Corporate Cab Rentals in Bangalore | Affordable Corporate Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Book one-month corporate cab rentals in Bangalore with Aaryan Travels. Affordable chauffeur-driven cabs for office transport, business travel, and corporate plans."
  />
  <meta
    name="keywords"
    content="One-Month Corporate Cab Rentals in Bangalore, Monthly Corporate Taxi Bangalore, Bangalore Corporate Cab Hire, 30 Day Business Cab Bangalore, Chauffeur Corporate Cab Bangalore, Office Cab Rental Bangalore, Long Term Cab Hire Bangalore, Corporate Transport Services Bangalore, Affordable One-Month Cab Bangalore, Executive Cab Bangalore, Corporate Vehicle Booking Bangalore, Business Cab Subscription Bangalore, Monthly Cab Plan Bangalore, Best Corporate Cab Bangalore, Company Cab Hire Bangalore"
  />
  <script type="application/ld+json">
    {JSON.stringify(oneMonthCorporateCabBangaloreSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/75.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onemonthcorporatecabrentalsinbanglore;